/**
 * Byte Comparison Component - Shows up/down/equal arrows comparing to baseline
 */

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown, faEquals } from '@fortawesome/free-solid-svg-icons';

const ByteComparison = ({ baselineBytes, testBytes }) => {
  const baseline = parseInt(baselineBytes) || 0;
  const test = parseInt(testBytes) || 0;

  if (baseline === 0 && test === 0) return null;

  const diff = test - baseline;
  const percentDiff = baseline > 0 ? Math.round((diff / baseline) * 100) : 0;
  // Precise magnitude (unrounded) used for the colour thresholds
  const absPercent = baseline > 0 ? Math.abs(diff) / baseline * 100 : 0;

  // Colour reflects how far the size deviates from baseline, so small "natural"
  // variations stay green and only meaningful deltas escalate to red.
  let color;
  if (absPercent < 1) color = 'text-green-500';
  else if (absPercent < 3) color = 'text-yellow-500';
  else if (absPercent < 6) color = 'text-orange-500';
  else color = 'text-red-500';

  // Icon reflects direction (larger / smaller / identical)
  let icon, title;
  if (Math.abs(diff) < 10) {
    icon = faEquals;
    title = 'Same size as baseline';
  } else if (diff > 0) {
    icon = faArrowUp;
    title = `+${diff} bytes (${percentDiff > 0 ? '+' : ''}${percentDiff}% larger)`;
  } else {
    icon = faArrowDown;
    title = `${diff} bytes (${percentDiff}% smaller)`;
  }

  return (
    <FontAwesomeIcon
      icon={icon}
      className={`${color} ml-1 text-xs`}
      title={title}
    />
  );
};

export default ByteComparison;
